import { arrayOf, objectOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isSdkDebuggerAppGroupIdAllResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      name: string,
      expiration_time: number,
      status: string,
    })
  ),
});
